import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHasPermission } from "../../../../hooks/useHasPermission";
import { IconApp } from "../../../IconApp";
import { NavLinkApp } from "../../../NavLinkApp";
import SidebarNavAccordion from "../../../SidebarNavAccordion";
import { useEffect } from "react";
import { startUIShowModulesCount } from "../../../../redux/actions/administrador/ui/ui";

export const Modules_Cashing = () => {
    const dispatch = useDispatch();
    const { hasPermission } = useHasPermission();
    const { color_text_menu_accordion } = useSelector((state) => state.config);

    const canShowAccordion = hasPermission([
        "INCOMES_BY_MONTH",
        "CURRICULA_TABULATORS_EDIT",
        "CURRICULA_TABULATORS",
        "TABULATORS",
        "TABULATORS_EDIT",
        "PAYMENTS",
        "EXTRAORDINARIES_CONTROL",
        "CONVENTIONS",
        "DISCOUNT_BILLING_MONTH",
        "EDUCATIONAL_CREDITS",
        "END_OF_MONTH",
        "ORPHAN_INSURANCE",
        "REVIEW_SCHOLAR_SERVICES_REQUESTS",
        "VOBO_CONTROL_SCHOLAR_SCHOLAR_SERVICES_REQUESTS",
        "VOBO_COORDINATION_SCHOLAR_SERVICES_REQUESTS",
    ]);

    useEffect(() => {
        if (canShowAccordion) {
            dispatch(startUIShowModulesCount("Modules_Cashing"));
        }
    }, [canShowAccordion]);

    return (
        <div>
            {canShowAccordion && (
                <SidebarNavAccordion
                    title={"Cobranza"}
                    itemLevel={0}
                    color={color_text_menu_accordion}
                    iconLeftClassName="fa-sharp fa-light fa-sack-dollar fa-xl"
                >

                    {hasPermission(["IMPORTED_FILES_BBVA"]) && (
                        <NavLinkApp
                            name="Archivos importados"
                            to="/app/imported-files"
                            icon={
                                <IconApp iconClassName="fa-solid fa-file-import c-sidebar-nav-icon"></IconApp>
                            }
                        />
                    )}
                    {hasPermission(["MARKET_CASHIER"]) && (
                        <NavLinkApp
                            name="Caja"
                            to="/app/market-cashier"
                            icon={
                                <IconApp iconClassName="fas fa-regular fa-cash-register c-sidebar-nav-icon"></IconApp>
                            }
                        />
                    )}
                    {hasPermission(["END_OF_MONTH"]) && (
                        <NavLinkApp
                            name="Cierre de mes"
                            to="/app/end-of-month"
                            icon={
                                <IconApp iconClassName="fas fa-regular fa-scale-balanced c-sidebar-nav-icon"></IconApp>
                            }
                        />
                    )}
                    {hasPermission(["PAYMENTS"]) && (
                        <NavLinkApp
                            name="Ingresos"
                            to="/app/payments"
                            icon={
                                <IconApp iconClassName="fa-solid fa-money-bill-wave c-sidebar-nav-icon"></IconApp>
                            }
                        />
                    )}
                    {hasPermission(["MARKET_CASHIER_ADMIN"]) && (
                        <NavLinkApp
                            name="Compras en caja"
                            to="/app/market-cashier/payments"
                            icon={
                                <IconApp iconClassName="fas fa-regular fa-sack-dollar c-sidebar-nav-icon"></IconApp>
                            }
                        />
                    )}
                    {hasPermission(["EXTRAORDINARIES_CONTROL"]) && (
                        <NavLinkApp
                            name="Control de extraordinarios"
                            to="/app/extraordinaries/control"
                            icon={
                                <IconApp iconClassName="fa-regular fa-person-circle-exclamation c-sidebar-nav-icon"></IconApp>
                            }
                        />
                    )}

                    {hasPermission(["EDUCATIONAL_CREDITS"]) && (
                        <NavLinkApp
                            name="Programa Apoyo Universitario"
                            to="/app/educational-credits"
                            icon={
                                <IconApp iconClassName="fa-solid fa-hand-holding-dollar c-sidebar-nav-icon"></IconApp>
                            }
                        />
                    )}

                    {hasPermission([
                        "REVIEW_SCHOLAR_SERVICES_REQUESTS",
                        "VOBO_CONTROL_SCHOLAR_SCHOLAR_SERVICES_REQUESTS",
                        "VOBO_COORDINATION_SCHOLAR_SERVICES_REQUESTS",
                    ]) && (
                        <NavLinkApp
                            name="Solicitudes de servicios"
                            to="/app/scholar-services/requests"
                            icon={
                                <IconApp iconClassName="fas fa-regular fa-basket-shopping-simple c-sidebar-nav-icon"></IconApp>
                            }
                        />
                    )}

                    {/* {hasPermision(["CURRICULA_TABULATORS"]) && ( */}

                    {hasPermission([
                        "CHARGE_BY_SUBJECT",
                        "CONVENTIONS",
                        "DISCOUNT_BILLING_MONTH",
                        "PAYMENTS",
                        "ORPHAN_INSURANCE",
                    ]) && (
                        <SidebarNavAccordion
                            title={"Formas de cobro"}
                            itemLevel={1}
                            color={color_text_menu_accordion}
                            iconLeftClassName="fa-solid fa-money-check-dollar-pen fa-xl"
                        >
                            {hasPermission(["CHARGE_BY_SUBJECT"]) && (
                                <NavLinkApp
                                    name="Cobro por materias"
                                    to="/app/charge-by-subjects"
                                    icon={
                                        <IconApp iconClassName="fas fa-regular fa-chalkboard-user c-sidebar-nav-icon"></IconApp>
                                    }
                                />
                            )}
                            {hasPermission(["CONVENTIONS"]) && (
                                <NavLinkApp
                                    name="Convenios"
                                    to="/app/conventions"
                                    icon={
                                        <IconApp iconClassName="fas fa-regular fa-money-bill-transfer c-sidebar-nav-icon"></IconApp>
                                    }
                                />
                            )}

                            {hasPermission(["DISCOUNT_BILLING_MONTH"]) && (
                                <NavLinkApp
                                    name="Descuentos"
                                    to="/app/discount"
                                    icon={
                                        <IconApp iconClassName="fas fa-regular fa-tag c-sidebar-nav-icon"></IconApp>
                                    }
                                />
                            )}

                            {hasPermission(["PAYMENTS"]) && (
                                <NavLinkApp
                                    name="Saldo a favor"
                                    to="/app/payments/positive-balance"
                                    icon={
                                        <IconApp iconClassName="fas fa-regular fa-money-check-dollar-pen c-sidebar-nav-icon"></IconApp>
                                    }
                                />
                            )}

                            {hasPermission(["ORPHAN_INSURANCE"]) && (
                                <NavLinkApp
                                    name="Seguro de orfandad"
                                    to="/app/orphan-insurance"
                                    icon={
                                        <IconApp iconClassName="fas fa-regular fa-hands-holding-child c-sidebar-nav-icon"></IconApp>
                                    }
                                />
                            )}
                        </SidebarNavAccordion>
                    )}

                    {hasPermission(["MASSIVE_INVOICE"]) && (
                        <SidebarNavAccordion
                            title={"Facturación"}
                            itemLevel={1}
                            color={color_text_menu_accordion}
                            iconLeftClassName="fa-solid fa-file-invoice-dollar fa-xl"
                        >
                            {hasPermission(["MASSIVE_INVOICE"]) && (
                                <NavLinkApp
                                    name="Facturación"
                                    to="/app/invoice-manual"
                                    icon={
                                        <IconApp iconClassName="fa-regular fa-receipt c-sidebar-nav-icon"></IconApp>
                                    }
                                />
                            )}
                            {hasPermission(["MASSIVE_INVOICE"]) && (
                                <NavLinkApp
                                    name="Facturación masiva"
                                    to="/app/massive-invoice"
                                    icon={
                                        <IconApp iconClassName="fa-solid fa-receipt c-sidebar-nav-icon"></IconApp>
                                    }
                                />
                            )}
                        </SidebarNavAccordion>
                    )}

                    {hasPermission([
                        "CURRICULA_TABULATORS_EDIT",
                        "CURRICULA_TABULATORS",
                        "TABULATORS",
                        "TABULATORS_EDIT",
                    ]) && (
                        <SidebarNavAccordion
                            title={"Catálogos"}
                            itemLevel={1}
                            color={color_text_menu_accordion}
                            iconLeftClassName="fa-sharp fa-regular fa-money-bill-trend-up fa-xl"
                        >
                            {hasPermission([
                                "CURRICULA_TABULATORS_EDIT",
                                "CURRICULA_TABULATORS",
                            ]) && (
                                <NavLinkApp
                                    name="Costos oferta educativa"
                                    to="/app/CurriculaTabulators/list"
                                    icon={
                                        <IconApp iconClassName="fa-solid fa-coins c-sidebar-nav-icon"></IconApp>
                                    }
                                />
                            )}

                            {hasPermission([
                                "TABULATORS",
                                "TABULATORS_EDIT",
                            ]) && (
                                <NavLinkApp
                                    name="Tabuladores docentes"
                                    to="/app/tabulators/list"
                                    icon={
                                        <IconApp iconClassName="fas fa-money-bill c-sidebar-nav-icon"></IconApp>
                                    }
                                />
                            )}
                        </SidebarNavAccordion>
                    )}
                </SidebarNavAccordion>
            )}
        </div>
    );
};
